import React from 'react'
import { Grid, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

const ItemText = styled(Typography)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'left',
  color: '#000000DE', //theme.palette.mode === 'dark' ? '#000000DE' : '#fff',
  fontWeight: '400',
  letterSpacing: '0.15px',
  lineHeight: '20px',
  fontSize: '14px',
}))

interface IInstructionGridItemProps {
  text: string
}
/**
 * InstructionGridItem
 *
 * @param __namedParameters IInstructionGridItemProps
 * @returns JSX.Element
 * @category ReactComponents
 */
export const InstructionGridItem: React.FC<IInstructionGridItemProps> = ({ text }) => (
  <Grid>
    <ItemText>{text}</ItemText>
  </Grid>
)
